import { Directive, Input, ViewContainerRef, TemplateRef } from '@angular/core';
import { UserService } from '../user/user.service';
import { Sider } from '../user/user.interface';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[acl]'
})
export class AclDirective {



  constructor(
    private user: UserService,
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>
  ) {
  }

  @Input('acl')
  set condition(acl: string[]) {
    // 系统代码
    const systemCode = acl[0];
    // 路由
    const elementRoute = acl[1];
    // 元素key
    const elementKey = acl[2];
    const tempArray: Array<Sider> = [];
    // tslint:disable-next-line: prefer-const
    let hasElement = false;
    // 过滤菜单通过 系统代码 路由
    this.filterMenuByAcl(this.filterSystemSider(systemCode), tempArray, elementRoute);
    tempArray.forEach((menu: Sider) => {
      if (menu.menuAuths.includes(elementKey)) {
        hasElement = true;
      }
    });
    if (hasElement) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  filterSystemSider(systemcode: string): Array<Sider> {
    return this.user.get().menu.filter((menu: Sider) => {
      return menu.systemCode === systemcode;
    });
  }

  filterMenuByAcl(
    menus: Array<Sider>,
    tempArray: Array<Sider>,
    elementRoute: string
  ): void {
    menus.forEach((menu: Sider) => {
      if (menu.children.length > 0) {
        this.filterMenuByAcl(menu.children, tempArray, elementRoute);
      } else {
        if (menu.link === elementRoute) {
          tempArray.push(menu);
        }
      }
    });
  }
}
